import React from 'react';
import PropTypes from 'prop-types';
import { MediaWrapper, LegacyMediaVideo, LegacyMediaImage, RemoveMedia } from './styles';

const LegacyMedia = ({ item, onRemove }) => {
  const { media_mime, media_preview, media_reference } = item;
  const onClick = () => onRemove && onRemove();
  const isEditor = !!onRemove;

  if (media_mime?.match(/video/)) {
    const src = `${new URL(media_preview).origin}/${media_reference}.mp4`;
    return (
      <MediaWrapper>
        <LegacyMediaVideo controls poster={media_preview}>
          <source src={src} type={media_mime} />
        </LegacyMediaVideo>
        {isEditor && <RemoveMedia onClick={onClick} tabIndex="0" title={i18n.__('app_remove')} />}
      </MediaWrapper>
    );
  } else if (media_mime?.match(/image/)) {
    return (
      <MediaWrapper className={isEditor ? '' : 'content-section'}>
        <LegacyMediaImage src={media_preview} alt={media_reference} />
        {isEditor && <RemoveMedia onClick={onClick} tabIndex="0" title={i18n.__('app_remove')} />}
      </MediaWrapper>
    );
  } else {
    return null;
  }
};

LegacyMedia.propTypes = {
  item: PropTypes.object.isRequired,
  onRemove: PropTypes.func,
};

export default LegacyMedia;
